export class ArrayError extends Error {
  messages: string[];
  constructor(messages: string | string[]) {
    super();
    this.name = 'ArrayError';
    this.messages = typeof messages === 'string' ? [messages] : messages;
    this.message = this.messages.join(', ');
  }
}
